/* eslint-disable react/prop-types */ // TODO: add props
import { Button } from 'edrolo-style-guide';
import { Link } from 'react-router-dom';
import style from './SwitchButton.scss';

export const SwitchButton = ({
  responsesUrl,
  allQuestionsUrl,
  analyticsPayload,
}) => {
  // The state of the "switch" is determined by which URL is passed
  // through as a prop. If both or neither of these URLs are passed
  // through we can't determine this state, and so we can't render anything.
  if (
    (responsesUrl && allQuestionsUrl) ||
    (!responsesUrl && !allQuestionsUrl)
  ) {
    return null;
  }

  let buttonText = '';
  if (responsesUrl) {
    buttonText = 'View responses';
  }
  if (allQuestionsUrl) {
    buttonText = 'View questions';
  }

  return (
    <>
      <Link
        to={responsesUrl || allQuestionsUrl}
        onClick={() =>
          global.analytics.track('toggled question set results view', {
            ...analyticsPayload,
          })
        }
        title={buttonText}
      >
        <Button className={style.switchButton}>{buttonText}</Button>
      </Link>
    </>
  );
};
